import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { massDeleteServices } from '../../../reducer';
import Loader from '../../../../../../components/Loaders/Loader';
import { servicesMassDelete } from '../../../../../../redux/actions/services';
import { getErrorMessage } from '../../../helpers/getters';
import { delay } from '../../../../../../utils/helper';
import ModalConfirm from '../../../../../../components/Modal/ConfirmLayouts';

const ModalMassDelete = ({ serviceDispatch, onClose }) => {
  const dispatch = useDispatch();
  const { servicesChecked } = useSelector((state) => state.services);

  const [form, setForm] = useState({
    isLoading: false,
    error: null,
    errorActiveSubscription: null,
    success: false,
  });
  const { isLoading, error, success, errorActiveSubscription } = form;

  const [servicesLength, setServicesLength] = useState(null);
  useEffect(() => {
    setServicesLength(servicesChecked.length);
  }, [servicesChecked.length]);

  const onConfirm = async () => {
    if (servicesChecked?.length) {
      try {
        const list = servicesChecked;
        setForm((prevState) => ({
          ...prevState,
          error: null,
          isLoading: true,
        }));
        await dispatch(servicesMassDelete(list));
        await setForm((prevState) => ({
          ...prevState,
          success: true,
        }));
        await delay(500);
        return await serviceDispatch(massDeleteServices(list));
      } catch (error) {
        /*
          Если есть активный Subscription
          Не давать удалять услугу
          Таска https://users.scrummate.com/#story/2156139/PNL-9719-Services-%D0%9D%D0%B5-%D0%B4%D0%B0%D0%B2%D0%B0%D1%82%D1%8C-%D1%83%D0%B4%D0%B0%D0%BB%D0%B8%D1%82%D1%8C-%D1%83%D1%81%D0%BB%D1%83%D0%B3%D1%83-%D0%B5%D1%81%D0%BB%D0%B8-%D0%BF%D0%BE-%D0%BD%D0%B5%D0%B9-%D0%B5%D1%81%D1%82%D1%8C-%D0%B0%D0%BA%D1%82%D0%B8%D0%B2%D0%BD%D1%8B%D0%B5-subscriptions
         */
        if (error?.data?.error_type === 'modal') {
          return setForm((prevState) => ({
            ...prevState,
            errorActiveSubscription: error.data,
            isLoading: false,
          }))
        }
        const errorMessage = getErrorMessage(error);
        return setForm((prevState) => ({
          ...prevState,
          error: errorMessage,
          isLoading: false,
        }))
      }
    }
  }

  return (
    <ModalConfirm.Wrapper>
      <Modal.Body>
        {error ? <div className="alert alert-danger">{error}</div> : null}
        {errorActiveSubscription
          ? (
            <>
              <ModalConfirm.TitleDescriptionWrapper>
                <ModalConfirm.Title>{errorActiveSubscription.error_header}</ModalConfirm.Title>
                <ModalConfirm.Description>
                  <div>{errorActiveSubscription.error_message}</div>
                </ModalConfirm.Description>
              </ModalConfirm.TitleDescriptionWrapper>
              <ModalConfirm.Actions>
                <Button
                  onClick={onClose}
                >
                  Close
                </Button>
              </ModalConfirm.Actions>
            </>
          )
          : (
            <>
              <ModalConfirm.TitleDescriptionWrapper>
                {isLoading ? <Loader success={success} /> : null}
                <ModalConfirm.Title>Delete services</ModalConfirm.Title>
                <ModalConfirm.Description>
                  <div>Are you sure you want to delete</div>
                  <div>
                    <b>{servicesLength || '0'}</b>
                    {' '}
                    services?
                  </div>
                </ModalConfirm.Description>
              </ModalConfirm.TitleDescriptionWrapper>
              <ModalConfirm.Actions>
                <Button
                  type="submit"
                  bsStyle="danger"
                  disabled={isLoading}
                  onClick={onConfirm}
                >
                  Delete
                </Button>
                <Button
                  disabled={isLoading}
                  onClick={onClose}
                >
                  Cancel
                </Button>
              </ModalConfirm.Actions>
            </>
          )}
      </Modal.Body>
    </ModalConfirm.Wrapper>
  );
};

ModalMassDelete.propTypes = {
  serviceDispatch: PropTypes.func,
  onClose: PropTypes.func,
}

export default ModalMassDelete;
